import { render, staticRenderFns } from "./AdminsList.vue?vue&type=template&id=c39ca810&"
import script from "./AdminsList.vue?vue&type=script&lang=js&"
export * from "./AdminsList.vue?vue&type=script&lang=js&"
import style0 from "./AdminsList.vue?vue&type=style&index=0&id=c39ca810&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports